import React, { Component } from 'react';
import { Row, Col, Icon } from 'antd';

export default class Code456 extends Component {
    constructor(props) { super(props); }
    render() {
        const { styleProps } = this.props;
        return (
            <div>
                <div {...styleProps.textDiv}>
                    <Icon type='lock' style={{ marginRight: '4px' }} />
                    {'Unable to login.'}
                </div>
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '4px' }}>
                    <Col span={14}>
                        {'Account is disabled.'}
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '16px' }}>
                    <Col span={11}>
                        <div style={{ fontStyle: 'italic', lineHeight: '14px' }}>
                            {'For further assistance, please contact FTSP Help at '}
                            <span style={{ fontWeight: 'bold' }}>
                                {'FTSP.Help@dhs.gov'}
                            </span>
                            {'.'}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
